import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import FiscalizacionesList from './FiscalizacionesList';

const Fiscalizaciones = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Normativa', icon: 'icon-leaf' },
		{ to: '#', label: 'Fiscalización', icon: 'icon-clipboard-check' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb 
						title='Fiscalizaciones' 
						links={breadcrumbLinks} 
						icon={'icon-clipboard-check'} 
					/>
					<FiscalizacionesList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Fiscalizaciones;
